import { put, call } from "redux-saga/effects";
import { visaCareLCAPAFDataAPI } from "../../utils/api/visaCareLCAPAFDataAPI";
import { CREATE_LCAPAF_COMPLETED, CREATE_LCAPAF_FAILED, UPDATE_LCAPAF_COMPLETED, UPDATE_LCAPAF_FAILED,
    GET_LCAPAFBYID_SUCCESS, GET_LCAPAFBYID_FAILED, GET_LCAPAFBYCHILDCASEID_SUCCESS, GET_LCAPAFBYCHILDCASEID_FAILED,
    GET_LCAPAFBYLISTCASEID_SUCCESS, GET_LCAPAFBYLISTCASEID_FAILED, GET_LCAPAFBYCOMPANYID_SUCCESS, GET_LCAPAFBYCOMPANYID_FAILED,
    GETALL_LCAPAF_SUCCESS, GETALL_LCAPAF_FAILED
} from "../actions/VisacareLCAPAFData";
 
export function* createLCAPAFData(request: any) {
  
    try {
           const result=yield call(visaCareLCAPAFDataAPI.createLCAPAFData, request.input);
         yield put({ 
            type: CREATE_LCAPAF_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: CREATE_LCAPAF_FAILED, payload: e.message });
    }
}

export function* updateLCAPAFData(request: any) {
   
    try {
           const result=yield call(visaCareLCAPAFDataAPI.updateLCAPAFData, request.input);
         yield put({ 
            type: UPDATE_LCAPAF_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_LCAPAF_FAILED, payload: e.message });
    }
}
export function* getLCAPAFById (request:any) {
    try {
      
        const { data } = yield call(visaCareLCAPAFDataAPI.getLCAPAFById,request);
    
      yield put({
          type: GET_LCAPAFBYID_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_LCAPAFBYID_FAILED, payload: e.message });
    }
  }

  export function* getLCAPAFByChildCaseId (request:any) {
    try {
      
        const { data } = yield call(visaCareLCAPAFDataAPI.getLCAPAFByChildCaseId,request);
    
      yield put({
          type: GET_LCAPAFBYCHILDCASEID_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_LCAPAFBYCHILDCASEID_FAILED, payload: e.message });
    }
  }

  export function* getLCAPAFByListCaseId (request:any) {
    try {
      
        const { data } = yield call(visaCareLCAPAFDataAPI.getLCAPAFByListCaseId,request);
    
      yield put({
          type: GET_LCAPAFBYLISTCASEID_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_LCAPAFBYLISTCASEID_FAILED, payload: e.message });
    }
  }

  export function* getLCAPAFByCompanyId (request:any) {
    try {
      
        const { data } = yield call(visaCareLCAPAFDataAPI.getLCAPAFByCompanyId,request);
    
      yield put({
          type: GET_LCAPAFBYCOMPANYID_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_LCAPAFBYCOMPANYID_FAILED, payload: e.message });
    }
  }

  export function* getAllLCAPAFData () {
    try {
      
        const { data } = yield call(visaCareLCAPAFDataAPI.getAllLCAPAFData);
    
      yield put({
          type: GETALL_LCAPAF_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GETALL_LCAPAF_FAILED, payload: e.message });
    }
    
  }